module.exports = __webpack_public_path__ + "img/1485010507.41aa81b4.jpg";